import environment from '../environment/index.js';
import cookie from '../cookie/index.js';
import JsonP from 'jsonp';
var gdssid = {
  get: function () {
    var env = environment.getEnv();
    var GDSID = cookie.getCookie(env + "GDSID");
    return new Promise(function (resolve) {
      if (!GDSID) {
        JsonP("https://" + environment.getApiEnv() + "apigateway.gaodun.com/vigo/api/v1/makeidentity", {
          param: 'callback'
        }, function (error, res) {
          if (!error) {
            cookie.setCookie(env + "GDSID", res.GDSID, 7 * 24 * 3600);
            resolve(res.GDSID);
          }
        });
      } else {
        resolve(GDSID);
      }
    });
  }
};
export default gdssid;